import { makeStyles } from "@material-ui/core/styles";

export const useTableStyles = makeStyles(
  theme => ({
    activeStatusText: {
      color: "#00C6A2",
      fontWeight: 600
    },
    activeTab: {
      color: "#0030FF",
      fontWeight: "bold"
    },
    boxStyles: {
      alignItems: "center",
      display: "flex",
      height: "50vh",
      justifyContent: "center",
      width: "100%"
    },
    boxStylesFullHeight: {
      height: "100%",
      overflow: "hidden"
    },
    btnBulkAction: {
      "& span": {
        color: "#0030FF"
      },
      "&.outlined": {
        "&:hover": {
          backgroundColor: "#ffffff"
        },
        backgroundColor: "#ffffff",
        border: "2px solid #0030FF"
      },
      "&.outlined span": {
        color: "#0030FF !important"
      },
      "&:last-child": {
        marginLeft: "10px"
      },
      backgroundColor: "#FFFFFF",
      color: "#0030FF"
    },
    btnTop: {
      "& span": {
        color: "#ffffff"
      },
      "&.outlined": {
        "&:hover": {
          backgroundColor: "#ffffff"
        },
        backgroundColor: "#ffffff",
        border: "2px solid #0030FF"
      },
      "&.outlined span": {
        color: "#0030FF !important"
      },
      "&:hover": {
        backgroundColor: "#0030FF"
      },
      "&:hover span": {
        color: "#ffffff"
      },
      "&:last-child": {
        marginLeft: "10px"
      },
      backgroundColor: "#0030FF",
      color: "#ffffff"
    },
    cardContent: {
      height: "100%",
      overflowX: "scroll",
      padding: "10px 0px",
      width: "100%"
    },
    colStatus: {
      width: "auto",
      [theme.breakpoints.down("md")]: {
        width: "auto"
      }
    },
    customTabs: {
      borderBottom: "1px solid #EEE",
      fontSize: "16px",
      minHeight: "40px",
      minWidth: "120px",
      textTransform: "none"
    },
    dataTitle: {
      display: "none !important"
    },
    inactiveStatusText: {
      color: "#747C8C",
      fontWeight: 600
    },
    inactiveTab: {
      color: "#BEBEBE",
      fontWeight: "bold"
    },
    itemsOdd: {
      backgroundColor: "#F4F8FF"
    },
    newCard: {
      display: "flex",
      gap: "10px"
    },
    noBordersTopBot: {
      borderBottom: "none",
      borderTop: "none"
    },
    responsiveTable: {
      overflow: "auto !important"
    },
    tableCellBody: {
      [theme.breakpoints.down("lg")]: {
        fontSize: "14px"
      }
    },
    tableCellCenter: {
      textAlign: "center"
    },
    tableCellHeader: {
      fontSize: "14px",
      fontWeight: 500,
      [theme.breakpoints.down("lg")]: {
        fontSize: "1em"
      }
    },
    tableCellHeaderMallSearch: {
      width: "350px !important"
    },
    tableCellHeaderMallSearchContainer: {
      height: "85px"
    },
    tableCellHeaderMallSearchNoResults: {
      "&:first-child:not(.MuiTableCell-paddingCheckbox)": {
        textAlign: "center"
      },
      color: "#747C8C",
      height: "350px !important",
      textAlign: "center",
      width: "100%"
    },
    tableHeader: {
      "& .formatted-text": {
        color: "#0030FF"
      },
      "&:hover": {
        "& .formatted-text": {
          color: "#0030FF"
        }
      },
      color: "#0030FF",
      fontSize: "18px",
      fontWeight: 600
    },
    tableHeaderCenter: {
      textAlign: "center"
    },
    tableHeaderTitle: {
      fontSize: "18px",
      fontWeight: 400
    },
    textBold: {
      fontWeight: "bold"
    },
    textCenter: {
      textAlign: "center"
    }
  }),
  { name: "AutoBookingTableStyles" }
);
